'use strict';

var attachmentsModule = angular.module('t2g.attachments', [
  'gettext',
  require('t2g.common.services.notificationService').name
]);

module.exports = attachmentsModule;

attachmentsModule.controller('AttachmentsCtrl', require('./AttachmentsCtrl'));
attachmentsModule.controller('AttachmentModalCtrl', require('./AttachmentModalCtrl'));

attachmentsModule.config(function ($stateProvider) {
  $stateProvider.state('private.main.attachments', {
    url: '/attachments',
    title: 'Attachments',
    templateUrl: 'https://cdn.termin2go.com/app/app/modules/attachments/AttachmentsView.html?v=3.94.5',
    controller: 'AttachmentsCtrl as AttachmentsCtrl',
    resolve: {
      office(OfficeDA) {
        return OfficeDA.get();
      },
    }
  });
});
